import { Base } from '@studiometa/js-toolkit';
import QuantityInput from './QuantityInput.js';
import SecretProperty from './SecretProperty.js';
import VariantRadios from './VariantRadios.js';

/**
 * Buybox component - manages product purchasing interface
 * Integrates with @studiometa/ui Fetch for automatic DOM updates
 */
export default class Buybox extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Buybox',
    components: {
      QuantityInput,
      SecretProperty,
      VariantRadios,
    },
    refs: ['form', 'buyButton', 'price[]'],
  };

  /**
   * Get form
   * @returns {HTMLFormElement}
   */
  get form() {
    return this.$refs.form;
  }

  /**
   * Get buy button
   * @returns {HTMLButtonElement}
   */
  get buyButton() {
    return this.$refs.buyButton;
  }
}
